import { render } from "./ManageMgmt.vue?vue&type=template&id=507a632d"
import script from "./ManageMgmt.vue?vue&type=script&lang=js"
export * from "./ManageMgmt.vue?vue&type=script&lang=js"

import "./ManageMgmt.vue?vue&type=style&index=0&id=507a632d&lang=css"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__